import type { MultiStepFormStep } from '#/components/Form/MultiStepForm/MultiStepFormTypes';
import type { I18nFn } from '#/i18n/types/I18nFn';

import { getOrgDetailFields } from './getOrgDetailFields';

export function getCreateFieldSteps(
  i18n: I18nFn,
  // oxlint-disable-next-line typescript/no-explicit-any
  values: any,
  // oxlint-disable-next-line typescript/no-explicit-any
  isInUS: any,
): MultiStepFormStep[] {
  return [
    {
      title: i18n('The Basics'),
      eventName: i18n('Create Org - The Basics'),
      showIntro: true,
      sections: [
        {
          title: i18n('What is your organization called?'),
          rows: [
            {
              fields: ['simpleName'],
              fieldsToValidate: ['name'],
            },
          ],
        },
        {
          title: i18n('Where is your organization located?'),
          rows: [
            {
              fields: ['locationType'],
            },
            {
              fields: ['address'],
            },
          ],
        },
        {
          title: i18n('Organization Type'),
          rows: [
            ...(isInUS
              ? [
                  {
                    fields: ['is501c3'],
                    fieldsToValidate: [
                      'is501c3',
                      'orgType',
                      'howToGetInvolved',
                      'timeActive',
                    ],
                  },
                ]
              : []),
            ...(!isInUS || (isInUS && values.is501c3 === false)
              ? [
                  {
                    fields: ['orgType'],
                  },
                ]
              : []),
            ...getOrgDetailFields({
              orgType: values.orgType,
            }),
          ],
        },
      ],
    },
    {
      title: i18n('Organization Details'),
      eventName: i18n('Create Org - Organization Details'),
      sections: [
        {
          rows: [
            ...(values.orgType === 'NONPROFIT'
              ? [
                  {
                    fields: ['mission'],
                  },
                ]
              : []),
            {
              fields: ['description'],
            },
            ...(values.orgType === 'CORPORATION'
              ? []
              : [
                  {
                    fields: ['areasOfFocus'],
                  },
                ]),
            {
              fields: ['orgContact'],
              fieldsToValidate: ['links', 'email', 'phone'],
            },
            {
              fields: ['locale'],
            },
            ...(![
              'CONSULTANT',
              'RECRUITER',
              'CORPORATION',
              'COMMUNITY',
            ].includes(values.orgType)
              ? [
                  {
                    fields: ['governmentId'],
                  },
                ]
              : [
                  {
                    fields: [],
                  },
                ]),
          ],
        },
      ],
    },
    {
      title: i18n('Using Idealist'),
      eventName: i18n('Create Org - Using Idealist'),
      sections: [
        {
          rows: [
            {
              fields: ['preferredListingTypes'],
            },
            ...(values.orgType === 'CORPORATION'
              ? []
              : [
                  {
                    fields: ['orgSize'],
                  },
                ]),
            {
              fields: ['inAccordance'],
            },
          ],
        },
      ],
    },
  ];
}
